import React from 'react';
import PropTypes from 'prop-types';
import { FormWrapper } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';
import { length, map } from 'ramda';

import { ReactComponent as IconBattery } from 'svg/battery-three-quarters-solid.svg';
import { ReactComponent as IconBolt } from 'svg/bolt-solid.svg';
import { ReactComponent as IconExclamationCircle } from 'svg/exclamation-circle-solid.svg';

import AdaptiveDataRow from 'components/DataBlock/AdaptiveDataRow';

import { NA } from 'constants/common';
import s from './styles.module.scss';

const TransmissionReportContent = ({
  alertValue,
  batteryLife,
  lastUpdated,
  pacingValue,
  shockValue,
  shocks,
  t,
}) => (
  <FormWrapper title={t('patient.deviceInformation')}>
    <AdaptiveDataRow iconClassName={s.iconStyle} title="Alert" icon={<IconExclamationCircle />}>
      {alertValue ? t('reports.alertInfoLabel') : t('reports.noAlertInfoLabel')}
    </AdaptiveDataRow>
    <AdaptiveDataRow
      iconClassName={s.iconStyle}
      title={t('reports.longevity')}
      icon={<IconBattery />}
    >
      <div style={{ color: batteryLife === 'The battery is at end of life' && 'red' }}>
        {batteryLife}
      </div>
    </AdaptiveDataRow>
    <AdaptiveDataRow title={t('reports.recordedShocks')} icon={<IconBolt />}>
      {length(shocks) ? map(({ id, dateTime }) => <div key={id}>{dateTime}</div>, shocks) : NA}
    </AdaptiveDataRow>
    <AdaptiveDataRow title={t('reports.deviceParameters')}>
      <div>
        {t('reports.lastUpdated')} {lastUpdated}
      </div>
      <div>{t('reports.pacingSettingsText', { value: pacingValue })}</div>
      <div>
        {t('reports.shockSettingsText', { value: shockValue || t('reports.notApplicable') })}
      </div>
    </AdaptiveDataRow>
  </FormWrapper>
);

TransmissionReportContent.propTypes = {
  alertValue: PropTypes.bool.isRequired,
  batteryLife: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  pacingValue: PropTypes.string.isRequired,
  shockValue: PropTypes.string.isRequired,
  shocks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      dateTime: PropTypes.string.isRequired,
    }),
  ).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TransmissionReportContent);
